module.exports = __webpack_public_path__ + "img/unselect-assess.efec93bc.svg";